import { atom } from 'jotai';

export const reActivationMailAtom = atom('');
export const registerMailAtom = atom('');
export const resetPasswordMailAtom = atom('');
